import React from "react";
import { CardComp } from "../index";
import FallbackImage from "./ImageWrapper";

const MemberInfoCard = ({ member, className = "" }) => {
  if (!member) {
    return null;
  }

  // Credit score UI paused until feature is implemented — do not show placeholder scores.
  // const getCreditScoreColor = (score) => {
  //   if (score >= 80) return "success";
  //   if (score >= 60) return "warning";
  //   if (score >= 40) return "info";
  //   return "danger";
  // };
  // const getCreditScoreLabel = (score) => {
  //   if (score >= 80) return "Excellent";
  //   if (score >= 60) return "Good";
  //   if (score >= 40) return "Fair";
  //   return "Poor";
  // };
  // const creditScoreColor = getCreditScoreColor(member.credit_score || 0);
  // const creditScoreLabel = getCreditScoreLabel(member.credit_score || 0);

  return (
    <div className={`member-info-card ${className}`}>
      <CardComp
        cardClassName="border border-primary bg-white shadow-sm"
        bodyClassName="p-4"
      >
        <div className="row align-items-center">
          {/* Member Photo and Basic Info */}
          <div className="col-md-6">
            <div className="d-flex align-items-center">
              <div className="me-3">
                <FallbackImage
                  src={member.photo || "/Images/TopHeader/avatar.svg"}
                  height="60"
                  width="60"
                  className="rounded-circle border border-2 border-primary"
                  alt="Member Photo"
                />
              </div>
              <div>
                <h5 className="mb-1 text-dark fw-bold">
                  {member.first_name} {member.last_name}
                </h5>
                <p className="mb-1 text-muted small">
                  <i className="fas fa-id-card me-1"></i>
                  Membership Number: {member.member_no || "N/A"}
                </p>
                <p className="mb-0 text-muted small">
                  <i className="fas fa-building me-1"></i>
                  {member.branch_name || "Main Branch"}
                </p>
              </div>
            </div>
          </div>

          {/* Loan stats (credit score hidden until implemented) */}
          <div className="col-md-6">
            <div className="d-flex justify-content-end">
              <div className="text-end">
                {/* Credit Score — paused until feature is ready
                <div className="mb-2">
                  <span className="text-muted small d-block">Credit Score</span>
                  <div className="d-flex align-items-center justify-content-end">
                    <span
                      className={`badge bg-${creditScoreColor} px-3 py-2 rounded-pill fw-bold`}
                    >
                      {member.credit_score || 0}%
                    </span>
                    <span
                      className={`ms-2 small text-${creditScoreColor} fw-bold`}
                    >
                      {creditScoreLabel}
                    </span>
                  </div>
                </div>
                */}

                {/* Additional Member Stats */}
                <div className="d-flex gap-3 justify-content-end">
                  <div className="text-center">
                    <div className="text-muted small">Total Loans</div>
                    <div className="fw-bold text-primary">
                      {member.total_loans || 0}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-muted small">Active Loans</div>
                    <div className="fw-bold text-warning">
                      {member.active_loans || 0}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-muted small">Repayment Rate</div>
                    <div className="fw-bold text-success">
                      {member.repayment_rate || 0}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Member Status and Eligibility */}
        <div className="row mt-3 pt-3 border-top">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <i className="fas fa-check-circle text-success me-2"></i>
                <span className="text-muted small">
                  Member since{" "}
                  {new Date(member.created_at).toLocaleDateString()}
                </span>
              </div>
              <div className="d-flex align-items-center">
                <span
                  className={`badge bg-${
                    member.is_eligible ? "success" : "danger"
                  } px-2 py-1`}
                >
                  <i
                    className={`fas fa-${
                      member.is_eligible ? "check" : "times"
                    } me-1`}
                  ></i>
                  {member.is_eligible ? "Eligible" : "Not Eligible"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </CardComp>
    </div>
  );
};

export default MemberInfoCard;
